import { render, staticRenderFns } from "./Patrocinadores.vue?vue&type=template&id=c625a4dc&scoped=true"
import script from "./Patrocinadores.vue?vue&type=script&lang=js"
export * from "./Patrocinadores.vue?vue&type=script&lang=js"
import style0 from "./Patrocinadores.vue?vue&type=style&index=0&id=c625a4dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c625a4dc",
  null
  
)

export default component.exports